import { Zap, Pill } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
import { Supplement } from '@/types/fitness';

interface SupplementsSectionProps {
  suplementos: Supplement[];
}

export function SupplementsSection({ suplementos }: SupplementsSectionProps) {
  return (
    <section id="energía" className="scroll-mt-32">
      <SectionHeader title="Energía" subtitle="Protocolo de Suplementos" icon={Zap} helpId="suplementos" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {suplementos.map((sup, index) => (
          <div
            key={index}
            className="bg-card p-6 rounded-xl shadow-sm border border-secondary hover:border-accent transition-all group hover:-translate-y-1 duration-300"
          >
            <div className="flex justify-between items-start mb-4">
              <span className="fitness-tag group-hover:bg-primary group-hover:text-accent transition-colors">
                {sup.hora}
              </span>
              {/* Pill se importa directo aquí en vez de venir como
               *  prop dentro del Supplement. Antes el ícono viajaba en
               *  `sup.icono` y eso rompía el caché offline: al
               *  serializar/deserializar a localStorage, el componente
               *  React se convertía en `{}` y React lanzaba #130.
               *  Ver IFT-011/IFT-012. */}
              <Pill className="text-muted-foreground/50 group-hover:text-accent transition-colors" size={24} />
            </div>
            <h4 className="text-xl font-black italic uppercase tracking-tighter mb-2 leading-none">
              {sup.nombre}
            </h4>
            <p className="text-xs font-bold text-muted-foreground uppercase tracking-wide border-t border-secondary pt-3 mt-3">
              Dosis: {sup.dosis}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
